import moment from "moment"
import { useContext, useEffect, useState } from "react"
import { Button, Card, Col, Container, Image, Modal, Row } from "react-bootstrap"
import { withTranslation } from "react-i18next"
import { FaExclamationTriangle } from "react-icons/fa"
import { RiArrowLeftSLine, RiArrowRightSLine } from "react-icons/ri"
import ReactPaginate from "react-paginate"
import Get from "../../api/Get"
import Put from "../../api/Put"
import { APPOINTMENT_CANCEL, APPOINTMENT_ONLY_PENDING, APPOINTMENT_UPDATE, PENDIENTES_CANCELAR, PENDIENTES_UPDATE } from "../../api/Routes"
import SimpleTable from "../../components/SimpleTable"
import { authContext } from "../../context/AuthContext"
import LoadingList from "../../loader/LoadingList"
import SimpleLoad from "../../loader/SimpleLoad"
import userDefault from '../../img/userdefault.png'
import Stars from "../../components/Stars"
import { IoMdCalendar } from "react-icons/io"
import Post from "../../api/Post"
import useCompanyType from "../../hook/useCompanyType"
import ModalSuccess from "../../components/ModalSuccess"
import ComponentModalErrorSever from "../../components/ComponentModalErrorSever"

function CitasAprobacion({t}){
    const [items, setItems] = useState([])
    const [page, setPage] = useState(0)
    const [count, setCount] = useState(20)
    const [order, setOrder] = useState('id')
    const [pageCount, setPageCount] = useState(0)
    const {auth} = useContext(authContext)
    const [loading, setLoading] = useState(true)
    const [showSuccess, setShowSuccess] = useState(false)
    const [search, setSearch] = useState("%20")  
    const [infoCita, setInfoCita] = useState(null) 
    const [idAprobar, setIdAprobar] = useState(null)
    const [show, setShow] = useState(false)
    const [messageAprobar, setMessageAprobar] = useState('')
    const [isAprobar, setIsAprobar] = useState(true)
    const [showInfo, setShowInfo] = useState(false)
    const [isSubmitting, setIsSubmiting] = useState(false)
    const companyType = useCompanyType()
    const [validExpediente, setValidExpediente] = useState(true)

    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleCloseServer = () => setShowModalError(false)

    const handleClose = () =>{
        setShow(false)
        setIdAprobar(null)
    }
    const handleCloseInfo = () =>setShowInfo(false)
    //console.log(idAprobar)
    useEffect(()=>{
        setLoading(true)
        const url = `${APPOINTMENT_ONLY_PENDING}/Pendiente/${page}/${count}/${order}/${search}`
        Get({url: url, access_token: auth.data.access_token})
        .then(response=>{
            console.log(response)
            setItems(response.data.data.appointmentDTOList)
            setPageCount(response.data.data.total)
            setLoading(false)
        })
        .catch(error=>{
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
            setLoading(false)
        })
    }, [page, count, search])

    const formatFechaCreacion = (cell) => {
        return moment(cell, "DD/MM/YYYY HH:mm").format("DD/MM/YYYY HH:mm")
    }

    const formatFechaCita = (cell, row) => {
        return moment(cell, "YYYY-MM-DDTHH:mm:ss").format("DD-MM-YYYY HH:mm")
    }

    const formatNamePaciente = (cell, row) => {
        return `${cell ? `${cell} ${row.patientDTO.name ? `${row.patientDTO?.middleName ?? ''} ${row.patientDTO.lastName} ${row.patientDTO?.seccondSurname ?? ''}` : ''}`: ''}`
    }

    const handleAprobar = (row, aprobar) =>{
        //console.log(row.expediente.trim()==="")
        if(companyType==="colombia"){
            if(aprobar){
                if(!row.expediente || row.expediente.trim() === ""){
                    setMessageAprobar('Debes asignar el número de expediente para poder aprobar la cita')
                    setValidExpediente(false)
                }else{
                    setValidExpediente(true)
                    setMessageAprobar('Seguro que desea aprobar la cita') 
                    setIsAprobar(aprobar)
                    setIdAprobar(row.id)
                }
                setShow(true)
            }else{
                if(!row.expediente || row.expediente.trim() === ""){
                    setMessageAprobar('Debes asignar el número de expediente para poder aprobar la cita')
                    setValidExpediente(false)
                }else{
                    setValidExpediente(true)
                    setMessageAprobar('Seguro que no desea aprobar la cita')
                    setIsAprobar(aprobar)
                    setIdAprobar(row.id)
                }     
                setShow(true)
            }            
        }else{
            if(aprobar){
                setMessageAprobar('Seguro que desea aprobar la cita')  
            }else{
                setMessageAprobar('Seguro que no desea aprobar la cita')
            }
            setIsAprobar(aprobar)
            setIdAprobar(row.id)
            setShow(true)
        }        
    }

    const handleChangeStatus = e =>{
        if(isAprobar){
            let data = {
                id: idAprobar,
                appointmentStatus: 'Pagada'
            }
            setIsSubmiting(true)
            Put({url: PENDIENTES_UPDATE, data: data, access_token: auth.data.access_token, header: true})
            .then(response=>{
                setIsSubmiting(false)
                let arr = items.filter(el=>el.id!==idAprobar)
                setItems(arr)
                setShow(false)
            })
            .catch(error=>{
                alert('error server')
                console.log(error)
                setShow(false)
            })
        }else{
            let data = {
                id: idAprobar,
                appointmentStatus: 'Pendiente'
            }
            //console.log(data)
            setIsSubmiting(true)
            Post({url: PENDIENTES_CANCELAR, data: data, header: true, access_token: auth.data.access_token})
            .then(response=>{
                setIsSubmiting(false)
                let arr = items.filter(el=>el.id!==idAprobar)
                setItems(arr)
                setShow(false)
            })
            .catch(error=>{
                alert('error server')
                console.log(error)
                setShow(false)
            })
        }        
    }

    const verCita = data =>{
        //console.log(data)
        setInfoCita(data)
        setShowInfo(true)
    }

    const actions = (cell, row, index) => {
        return (
            <div>
                <ul className="list-inline mb-0">                    
                    <li className="list-inline-item"><span className="badge badge-success cursor-pointer" onClick={e=>handleAprobar(row, true)}>Aprobar</span></li>
                    <li className="list-inline-item"><span className="badge badge-danger cursor-pointer" onClick={e=>handleAprobar(row, false)}>No aprobar</span></li>
                    <li className="list-inline-item"><span className="badge badge-info cursor-pointer" onClick={e=>verCita(row)}>Ver cita</span></li>
                </ul>          
            </div>
        );
    }

    const formatMinutsTranscurridos = (cell, row) => {
        //console.log(row)
        let currentTime = moment(row.currentTime, "DD/MM/YYYY HH:mm:ss")
        let createdAt = moment(row.createdAt, "DD/MM/YYYY HH:mm:ss")
        let diffMinuts = currentTime.diff(createdAt, "m")
        return <span className={`badge align-minuts ${diffMinuts <= 30 ? 'badge-success' : diffMinuts <= 45 ? 'badge-warning' : 'badge-danger'}`}>{diffMinuts}</span>
    }

    const columns = [
        {
            dataField: 'id',
            text: 'ID',
            hidden: true
        },
        {
            dataField: 'createdAt',
            text: 'Fecha creación',
            headerStyle: { width: '10%' },
            formatter: formatFechaCreacion,
            editable: false  
        },
        {
            dataField: 'scheduleDTO.dateTimeInit',
            text: 'Fecha cita',
            headerStyle: { width: '10%' },
            formatter: formatFechaCita,  
            editable: false
        },
        {
            dataField: 'minuts',
            text: 'Minutos trans.',
            headerStyle: { width: '10%', textAlign: 'center' },
            style: {textAlign: 'center'},
            formatter: formatMinutsTranscurridos,
            editable: false  
        },
        {
            dataField: 'expediente',
            text: 'No. expediente',
            headerStyle: { width: '15%' },
            editable: companyType==="colombia" ? true : false,
            hidden: companyType==="colombia" ? false : true,
            validator: (newValue, row, column) => {    
                if (newValue !== row?.expediente){
                    let values = {
                        id: row.id,
                        'expediente': newValue,
                    }
                    Put({url: APPOINTMENT_UPDATE, data: values, header:true, access_token:auth.data.access_token})
                    .then(resp=>{
                        //console.log(resp)
                        setShowSuccess(true)
                    })
                    .catch(error=>{
                        alert('error server')
                    })
                }
                
                return true;
              }
        },
        {
            dataField: 'patientDTO.name',
            text: 'Paciente',
            headerStyle: { width: '20%' },
            formatter: formatNamePaciente,  
            editable: false
        },
        {
            dataField: 'patientDTO.account.name',
            text: 'Cliente corporativo',
            headerStyle: { width: '20%' },
            editable: false
        },
        {
            dataField: 'speciality.name',
            text: 'Especialidad',
            headerStyle: { width: '15%' },
            editable: false
        },
        {
            dataField: '',
            isDummyField: true,
            text: t('acciones'),
            headerStyle: { width: '10%' },
            formatter: actions,  
            editable: false          
        }
    ]

    const handlePageClick = (data) =>{
        setPage(data.selected)
    }

    useEffect(() => {
        const interval =setInterval(()=>{                     
            const url = `${APPOINTMENT_ONLY_PENDING}/Pendiente/${page}/${count}/${order}/${search}`
            Get({url: url, access_token: auth.data.access_token})
            .then(response=>{
                console.log(response)
                setItems(response.data.data.appointmentDTOList)
                setPageCount(response.data.data.total)
                setLoading(false)
            })
            .catch(error=>{
                setShowModalError(true)
                if(error.response){
                    setErrorServer(error.response)
                }
                setLoading(false)
            })
        }, 60000)

        return () => clearInterval(interval);
    }, [])

    return(
        <Container fluid className="my-5">
            <Row className="align-items-center">
                <Col xs="12" md="8">
                    <h2 className="mb-0 title-top">Citas para aprobación</h2>
                </Col>                
            </Row>
            <Row>
                <Col>
                    <Card className="shadow-1 mt-3">
                        <Card.Body>
                            {loading && <LoadingList />}
                            <SimpleTable columns={columns} items={items} className="th-text-uppercase" edit={true} />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <Row className="mt-4">
                <Col xs="12" md="10">
                    <ReactPaginate
                        previousLabel={<RiArrowLeftSLine />}
                        nextLabel={<RiArrowRightSLine />}
                        breakLabel={'...'}
                        breakClassName={'break-me'}
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        containerClassName={'pagination'}
                        subContainerClassName={'pages pagination'}
                        activeClassName={'active'}
                    />
                </Col>
                <Col className="d-none d-md-block" xs="12" md="2">
                    <select className="select-pagin" onChange={e=>setCount(e.target.value)}>
                        <option value="20">20 / {t('pagina')}</option>
                        <option value="30">30 / {t('pagina')}</option>
                        <option value="50">50 / {t('pagina')}</option>
                    </select>
                </Col>
            </Row>
            <Modal show={show} onHide={handleClose} centered className="border-0">
                <Modal.Body className="p-2">                    
                    <div className="text-center position-relative overflow-hidden">
                        {isSubmitting && <SimpleLoad />}
                        <div>
                            <div>
                                <div><FaExclamationTriangle className="text-warning" /></div>
                                <h5 className="mt-2 mb-0">{messageAprobar}</h5>
                            </div>
                            <div className="mt-2">
                                <Button variant="light" onClick={handleClose}>Regresar</Button>{' '}
                                {
                                    validExpediente && 
                                    <Button variant={isAprobar ? "secondary" : 'danger'} onClick={handleChangeStatus}>Confirmar</Button> 
                                }
                                
                            </div>
                        </div>                        
                    </div>                                   
                </Modal.Body>
            </Modal>
            <Modal show={showInfo} onHide={handleCloseInfo} size="lg">
                <Modal.Body>
                    {infoCita && <Row>
                        <Col xs="12" md="6">
                            <h4 className="color-blue-dark">{t('paciente_informacion')}</h4>
                            <h6 className="text-dark-50 mb-4">{infoCita && `${infoCita.patientDTO.name} ${infoCita.patientDTO.middleName ?? ''} ${infoCita.patientDTO.lastName} ${infoCita.patientDTO.seccondSurname ?? ''}`}</h6>
                            <Row className="font-size-09rem">                                
                                <Col xs="6" md="6"><label className="mb-2"><strong>{t('Genero')}: </strong>{infoCita ? (infoCita.patientDTO.gender==='Male'? t('Masculino') : t('Femenino')) : '-'}</label></Col>
                                <Col xs="6" md="6"><label className="mb-2"><strong>{t('Tiposangre')}: </strong>{infoCita.patientDTO ? infoCita.patientDTO.bloodType : '-'}</label></Col>
                                <Col xs="6" md="6"><label className="mb-2"><strong>{t('Telefono')}: </strong>{infoCita.patientDTO ? infoCita.patientDTO.phone : '-'}</label></Col>
                                <Col xs="6" md="12"><label className="mb-2"><strong>Teléfono alterno: </strong>{infoCita.patientDTO?.phone2 ? infoCita.patientDTO.phone2 : '-'}</label></Col>
                                <Col xs="12" md="12"><label className="mb-2"><strong>{t('Correoelectronico')}: </strong>{infoCita.patientDTO ? infoCita.patientDTO.email : '-'}</label></Col>
                                <Col xs="12" md="12"><label className="mb-2"><strong>Cliente corporativo: </strong>{infoCita.patientDTO && infoCita.patientDTO.account?.partner?.name}</label></Col>
                                <Col xs="12" md="12"><label className="mb-2"><strong>Cuenta: </strong>{infoCita.patientDTO && infoCita.patientDTO.account?.name}</label></Col>
                                {
                                    companyType === "colombia" &&
                                    <>
                                        <Col xs="12" md="12">
                                            <label className="mb-2"><strong>Documento de identidad: </strong> {infoCita.patientDTO ? `${infoCita.patientDTO.identityDocumentType?.code}  ${infoCita.patientDTO.documentNumber}` : '-' }</label>
                                        </Col>
                                        {infoCita.patientDTO.titular && <Col xs="12" md="12">
                                            <strong>Documento de identidad titular: </strong>
                                            {
                                                infoCita.patientDTO.account === 144 ? '-' :
                                                `${infoCita.patientDTO.titular.identityDocumentType?.code}  ${infoCita.patientDTO.titular.documentNumber}`
                                            }
                                        </Col>}
                                    </>
                                                                        
                                }
                                {(infoCita.patientDTO?.account?.id === 57 || infoCita.patientDTO?.account?.id === 144) && 
                                <Col xs="12" md="12"><label className="mb-2"><strong>Ciudad: </strong>{infoCita.patientDTO && infoCita.patientDTO.state?.name}</label></Col>}
                            </Row>
                        </Col>
                        <Col xs="12" md="6">
                            <h4 className="color-blue-dark mb-2">{t('informacion_cita')}</h4>
                            <Row className="align-items-center">
                                <Col xs="12" md="4" className="m-auto">
                                    {infoCita && <Image src={infoCita.scheduleDTO.doctor.url_photo ? infoCita.scheduleDTO.doctor.url_photo : userDefault} fluid className="img-card-citas img-card-doctors"/>}
                                </Col>
                                <Col xs="12" md="8">
                                    {infoCita && <h5 className="mb-1 text-dark-50 font-weight-bold">{`${infoCita.scheduleDTO.doctor?.name} ${infoCita.scheduleDTO.doctor?.lastName}`}</h5>}
                                    {infoCita && <label className="mb-1">Proveedor: {infoCita.scheduleDTO.doctor?.providerService?.name ?? ''}</label>}
                                    {infoCita && <label className="mb-0 d-block text-dark-50 font-weight-light font-size-16rem">{infoCita.speciality.name}</label>}                                    
                                    {infoCita && <Stars stars={null} />}
                                    <label><IoMdCalendar /> {moment(infoCita.scheduleDTO.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").format('DD MMMM YYYY, HH:mm')} hrs</label>
                                </Col>
                            </Row>
                            {(infoCita.patientDTO?.account?.id === 57 || infoCita.patientDTO?.account?.id === 144) && 
                            <Row className="mt-3">
                                <Col xs="12" md="12"><label className="mb-2"><strong>Motivo de consulta: </strong>{infoCita.motivoConsulta && infoCita.motivoConsulta}</label></Col>
                            </Row>}
                        </Col>
                    </Row>}

                    <Row className="my-3">
                        <Col className="text-right">
                            <Button variant="secondary" onClick={handleCloseInfo}>Aceptar</Button>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
            <ModalSuccess show={showSuccess} setShow={setShowSuccess}/>
            <ComponentModalErrorSever 
                show={showModalError}
                handleClose={handleCloseServer}
                error={errorServer}
            />
        </Container>
    )
}

export default withTranslation()(CitasAprobacion)